import { AccordionSection } from 'components/Accordion';
import { Text } from 'components/Text';
import { getLocaleLanguage, getTrans } from 'modules/i18n';
import {
  getiOSBrowserInstructions,
  getiOSDeviceInstructions,
  iosBrowserImages,
  iosBrowserVideoUrl,
  iosDeviceImages,
  iosSystemVideoUrl
} from '../constants';
import { Instructions } from './Instructions';
import { SizedBox } from './SizedBox';
import { Video } from './Video';

export const IOSInstructions = () => {
  const localeLanguage = getLocaleLanguage();

  const iOSDeviceInstructions = getiOSDeviceInstructions();
  const iOSBrowserInstructions = getiOSBrowserInstructions();

  return (
    <>
      <AccordionSection
        title={getTrans('geolocationSettingsPage.instructions.device.title')}
      >
        <Video videoUrl={iosSystemVideoUrl} />
        <Instructions
          instructions={iOSDeviceInstructions}
          images={iosDeviceImages[localeLanguage]}
        />
        <SizedBox>
          <Text variant="body2" mt={1}>
            <b>{getTrans('geolocationSettingsPage.instructions.ios6.part1')}</b>
            &nbsp;
            {getTrans('geolocationSettingsPage.instructions.ios6.part2')}
            <br />
            {getTrans('geolocationSettingsPage.instructions.ios6.part3')}&nbsp;
            <b>{getTrans('geolocationSettingsPage.instructions.ios6.part4')}</b>
            &nbsp;
            {getTrans('geolocationSettingsPage.instructions.ios6.part5')}
          </Text>
        </SizedBox>
      </AccordionSection>
      <AccordionSection
        title={getTrans('geolocationSettingsPage.instructions.browser.title')}
      >
        <Video videoUrl={iosBrowserVideoUrl} />
        <Instructions
          instructions={iOSBrowserInstructions}
          images={iosBrowserImages[localeLanguage]}
        />
        <SizedBox>
          <Text variant="body2" mt={1}>
            <b>
              {getTrans(
                'geolocationSettingsPage.instructions.browser.final.part1'
              )}
            </b>
            &nbsp;
            {getTrans(
              'geolocationSettingsPage.instructions.browser.final.part2'
            )}
          </Text>
        </SizedBox>
      </AccordionSection>
    </>
  );
};
